import { StyleSheet, Dimensions, Platform } from 'react-native';
import { FULL_WIDTH, MODAL_MAX_WIDTH } from './shared/constants/dimension';

const { width } = Dimensions.get('window');

const getGlobalStyles = (theme?: any) => StyleSheet.create({
    scale: {
        transform: Platform.OS === 'web' ? [{ scaleX: 0.8 }, { scaleY: 0.8 }] : []
    },
    backdrop: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(13, 13, 13, 0.40)',
    },
    hCenter: {
        width: width,
        alignItems: 'center',
    },
    centerRow: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    centerColumn: {
        gap: 16,
        justifyContent: 'space-around',
        flexDirection: 'column',
        width: FULL_WIDTH
    },
    centerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
    },
    centerMessage: {
        color: theme?.colors?.primary,
        fontSize: 32,
        fontWeight: 600,
        textAlign:'center'
    },
    header1: {
        color: theme?.colors?.headerText,
        fontSize: 20,
        fontWeight: 600,
        lineHeight: 28
    },
    header2: {
        color: theme?.colors?.headerText,
        fontSize: 16,
        fontWeight: 400,
    },
    header3: {
        color: theme?.colors?.headerText,
        fontSize: 13,
        fontWeight: 400,
    },
    subtitle: {
        color: theme?.colors?.subtleText,
        fontSize: 12,
        fontWeight: 500,
        textAlign: 'center',
        marginBottom: 10,
        lineHeight: 20,
        letterSpacing: 1
    },
    body: {
        fontWeight: 300,
        fontSize: 14,
        marginTop: 16,
        color: theme?.colors?.bodyText,
    },
    note: {
        fontWeight: 300,
        color: theme?.colors?.secondary,
        fontSize: 12,
    },
    fullWidth: {
        width: width,
        maxWidth: MODAL_MAX_WIDTH,
    },

    fullWidthWithMargin: {
        width: width - 50,
        maxWidth: MODAL_MAX_WIDTH - 50,
    },
    fullWidthButton: {
        display: 'flex',
        flexDirection: 'row',
        width: width - 50,
        maxWidth: MODAL_MAX_WIDTH,
        padding: 16,
        margin: 16,
        gap: 12,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10
    },
    buttonStyle: {
        height: 40,
        borderRadius: 20,
        backgroundColor: theme?.colors?.btnBgFill,
        alignContent: 'center',
        justifyContent: 'center',
        borderColor: theme?.colors?.primary,
        borderWidth: 1.5,
        borderStyle:'solid'
    },
    buttonActiveStyle: {
        backgroundColor: theme?.colors?.primary,
    },
    rectangularButton: {
        borderRadius: 12,
    },
    buttonLabelStyle: {
        color: theme?.colors?.primary,
        ...theme?.fonts?.bodySmall,
        lineHeight: 19,
    },
    buttonActiveLabelStyle: {
        color: theme?.colors?.surfaceColor,
        ...theme?.fonts?.bodySmall,
        lineHeight: 19,
    },
    shadow: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 4,
    },
    categoryChip: {
        borderWidth: 1,
        borderRadius: 8,
        backgroundColor: 'rgba(13, 13, 13, 0.60)',
    },
    transparent: {
        backgroundColor: 'transparent',
        borderColor: 'transparent'
    },

    closeButton: {
        position: "absolute",
        right: 24,
        padding: 6,
        paddingHorizontal: 8,
        borderWidth: 1,
        borderRadius: 200
    },

    buttonCircle: {
        width: 32,
        height: 32,
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center"
    },

    webCard: {
        borderRadius: 20,
        maxWidth: 950,
        width: FULL_WIDTH,
        alignSelf: 'center'
    },

    link: {
        textDecorationLine: "none",
        borderBottomWidth: 1,
        cursor: "pointer",
        fontSize: 16,
        fontWeight: 400,
        borderColor: theme?.colors?.textPrimary
    },
    gradientBorderShadow: {
        width: "100%",
        borderRadius: 20,
        padding: 10,
        shadowColor: "#000",
        shadowOpacity: 0.06,
        shadowRadius: 10,
        shadowOffset: { width: 0, height: 4 },
        borderWidth: 1,
        borderColor: "#FFFFFF",
        // Shadow for Android
        elevation: 4,
      },
      bubbleBorder: {
        width: 70,
        height: 70,
        borderWidth: 1,
        borderColor: theme?.colors?.primary,
        borderRadius: 35,
        padding: 4,
      }
});

export default getGlobalStyles;